import React from "react";
import {
  Color,
  FontStyle,
  JobDisplays,
  READY_EMPLOYER,
  VideoOrientation,
} from "../../constants";
import JobFeatureVid from "./JobFeatureVid";
import { Box, Stack } from "@mui/material";
import { JobFontSize } from "../../utils/jobUtils";
import iconSrc from "../../img/icons8/lightbulb.png";

export const AdBanner = ({ company, isPanel = false }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={isPanel ? "center" : "flex-start"}
      spacing={1}
      sx={{
        //   width: "180px",
        width: "100%",
        borderRadius: JobDisplays.borderRadius,
        backgroundColor: JobDisplays.backgroundColor,
        ...(isPanel
          ? {
              boxShadow: JobDisplays.boxShadow,
              textAlign: "center",
              padding: JobDisplays.padding,
              fontSize: JobFontSize.title,
            }
          : {
              paddingTop: "4px",
              fontSize: JobFontSize.large,
            }),
      }}>
      <Box sx={{ ...FontStyle.headingBody }}>
        {isPanel && (
          <img
            src={iconSrc}
            alt="lightbulb"
            style={{
              height: "24px",
              position: "relative",
              top: "4px",
            }}
          />
        )}{" "}
        Get To Know {company}
      </Box>
    </Stack>
  );
};

const JobVerticalVideoAd = ({ job, mobile }) => {
  const {
    jobId,
    company,
    jobTitle,
    location,
    roleToken,
    experienceLevel,
    jobDescription,
    url,
    vidUrl,
    vidSize,
  } = job;
  const showVideo =
    vidUrl && vidSize === VideoOrientation.portrait && READY_EMPLOYER;
  if (!showVideo) return null;

  return (
    <Stack
      direction="column"
      //   alignItems="center"
      sx={{ width: "100%", zIndex: 1, position: "relative" }}
      spacing={1}>
      <AdBanner company={company} isPanel />
      <Box sx={{ width: "100%" }}>
        <JobFeatureVid vidUrl={vidUrl} vidSize={vidSize} shadow />
      </Box>
    </Stack>
  );
};

export default JobVerticalVideoAd;
